// -----------------------------------------------------------------------------
// PLUGINS/TEXT
// -----------------------------------------------------------------------------
import { keymap } from "prosemirror-keymap";
import { history } from "prosemirror-history";
import { baseKeymap } from "prosemirror-commands";
import { dropCursor } from "prosemirror-dropcursor";
import { addListNodes } from "prosemirror-schema-list";
import { Schema } from "prosemirror-model";
import { EditorState } from "prosemirror-state";
import { EditorView } from "prosemirror-view";
// -----------------------------------------------------------------------------
import { paragraph, blockquote, text, hard_break, em, link, strong } from "../schema";
import { buildKeymap } from "../plugins/keymap";
import { buildInputRules } from "../plugins/inputrules";
import { menuPlugin } from "../plugins/menu";
import { elmPlugin } from "../plugins/elm";
import items from "../menu/elems";
// -----------------------------------------------------------------------------
export function textEditor(container, id, doc, app) {
    const schema = textSchema();
    const config = {
        schema: schema,
        plugins: plugins(container, schema, id, app)
    };
    if (doc) {
        return new EditorView(container.inner, {
            state: EditorState.create({
                doc: schema.nodeFromJSON(doc),
                plugins: config.plugins
            })
        });
    }
    else {
        return new EditorView(container.inner, {
            state: EditorState.create(config)
        });
    }
}
export function textSchema() {
    const base = new Schema({
        nodes: { doc: { content: "block+" }, paragraph, blockquote, text, hard_break },
        marks: { em, link, strong }
    });
    return new Schema({
        nodes: addListNodes(base.spec.nodes, "paragraph block*", "block"),
        marks: base.spec.marks
    });
}
function plugins(containers, schema, id, app) {
    return [
        menuPlugin(containers, menu, false, id, app),
        buildInputRules(schema),
        keymap(buildKeymap(schema)),
        keymap(baseKeymap),
        dropCursor(),
        history(),
        elmPlugin(id, app)
    ];
}
const menu = [
    items.link,
    items.em,
    items.strong,
    items.paragraph,
    items.blockquote,
    items.orderedList,
    items.bulletList,
];
